
<section>
  <div class="wrapper">
      <article class="mrt-75" style="overflow: hidden !important;min-height: calc(100vh - 117px);z-index: 0;
      margin-bottom: 50px;">
        <div>
          <mat-tab-group>
            <mat-tab label="Core Infrastructure Health" (click)="selectTab(1)" style="font-family: 'Roboto', sans-serif;color:#294058">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="right-column" style="width: 100%;">
                          <h2 class="heading_colum" style="width:auto !important;text-align: center;">Top Hosts By CPU (Realtime)</h2>
                          <div class="main_box">
                            <div style="display: inline-flex;" *ngFor="let item of cpuData">
                              <div class="right-sub-column-1 left colum_design" >
                                 <p class="node_para">{{item.nodeName}}</p> 
                              </div>
                              <div class="right-sub-column-2 center mobile_res"  style="width:270px;height:15px">
                                <div class="progress-container" style="margin-left: 3px;">
                                  <mat-progress-bar style="height: 15px;width: 250px;" mode="determinate" [value]="item.percentage" [color]="getProgressColor(item.percentage)"></mat-progress-bar>
                                </div>
                              </div>
                                <div class="right-sub-column-3 right"  style="width:auto;height:15px">
                              {{item.percentage}}%
                            </div>
                            </div>
                          </div>                    
                        </div>
                        <div *ngIf="data.length==0" class="no-data text-primary m-t-15" style="font-size: large;text-align: center;">
                          {{loadingCPUMessage}}
                      </div>
                      </div>
                      <div class="col-md-6">
                        <div class="right-column" style="width: 100%;">
                          <h2 class="center heading_colum" style="width:auto !important;text-align: center;">Top Hosts By Memory (Realtime)</h2>
                          <div class="main_box">
                            <div style="display: inline-flex;" *ngFor="let item of ramData">
                              <div class="right-sub-column-1 left colum_design">
                                  <p class="node_para">{{item.nodeName}}</p>
                              </div>
                              <div class="right-sub-column-2 center"  style="width:270px;height:15px">
                                <div class="progress-container" style="margin-left: 3px;">
                                  <mat-progress-bar style="height: 15px;width: 250px;" mode="determinate" [value]="item.percentage" [color]="getProgressColor(item.percentage)"></mat-progress-bar>
                                </div>
                              </div>
                                <div class="right-sub-column-3 right"  style="width:auto;height:15px">
                              {{item.percentage}}%
                            </div>
                            </div>
                          </div>                      
                        </div>
                        <div *ngIf="data.length==0" class="no-data text-primary m-t-15" style="font-size: large;text-align: center;">
                          {{loadingRAMMessage}}
                       </div>
                      </div>
                    </div>
                  </div>
            </mat-tab>
            <mat-tab label="Infrastructure Health Details" (click)="selectTab(2)" style="font-family: 'Roboto', sans-serif;color: #294058;">
              <div class="tab2">
                <div #grafanaContainer class="grafana-container">
                  <iframe src="https://grafana.pro-vigil.info/d/XP62GzKnz/microservices?orgId=1&refresh=30s" width="100%" height="1050"></iframe>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
          
      </div>    
      </article>         
   
  </div>
</section>